import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import Signup from "./components/Signup";
import Login from "./components/Login";
import Chatbot from "./components/Chatbot";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import About from "./components/About";
import "bootstrap/dist/css/bootstrap.min.css";

// For handling tokens in the URL, etc.
const RedirectToSignup = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  if (token) {
    console.log("🔄 Redirecting to Signup with Token:", token);
    return <Navigate to={`/signup?token=${token}`} replace />;
  } else {
    console.log("🔄 No Token Found. Redirecting to Login.");
    return <Navigate to="/login" replace />;
  }
};

export default function App() {
  return (
    <Router>
      <Routes>
        {/* 1) Route for / => redirect to /login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/about" element={<About />} />

        <Route element={<PrivateRoute />}>
          <Route path="/chat" element={<Chatbot />} />
          <Route path="/chat-sw" element={<Chatbot />} />
        </Route>

        {/* 2) Fallback for anything else => token logic or login */}
        <Route path="*" element={<RedirectToSignup />} />
      </Routes>
    </Router>
  );
}
